import React, { Component } from 'react'

class ResumeStep1 extends Component {
    render() {
        return (
            <div>
                In Step 1!
            </div>
        )
    }
}

export default ResumeStep1
